import K from "lodash/merge.js";
import Se from "lodash/debounce.js";
import Ne from "lodash/isEmpty.js";
import Re from "lodash/toPairs.js";
function we(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Me(e) {
  if (Array.isArray(e))
    return e;
}
function je(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ve(e, t, r, n, a, u, s) {
  try {
    var l = e[u](s), h = l.value;
  } catch (d) {
    return void r(d);
  }
  l.done ? t(h) : Promise.resolve(h).then(n, a);
}
function j(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, a) {
      var u = e.apply(t, r);
      function s(h) {
        ve(u, n, a, s, l, "next", h);
      }
      function l(h) {
        ve(u, n, a, s, l, "throw", h);
      }
      s(void 0);
    });
  };
}
function xe(e, t, r) {
  return t = te(t), Ge(e, Le() ? Reflect.construct(t, r || [], te(e).constructor) : t.apply(e, r));
}
function pe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ue(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, De(n.key), n);
  }
}
function me(e, t, r) {
  return t && Ue(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function V(e, t, r) {
  return (t = De(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function te(e) {
  return te = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, te(e);
}
function Fe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ce(e, t);
}
function Le() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Le = function() {
    return !!e;
  })();
}
function qe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, u, s, l = [], h = !0, d = !1;
    try {
      if (u = (r = r.call(e)).next, t !== 0)
        for (; !(h = (n = u.call(r)).done) && (l.push(n.value), l.length !== t); h = !0)
          ;
    } catch (p) {
      d = !0, a = p;
    } finally {
      try {
        if (!h && r.return != null && (s = r.return(), Object(s) !== s))
          return;
      } finally {
        if (d)
          throw a;
      }
    }
    return l;
  }
}
function He() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ge(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return je(e);
}
function E() {
  E = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, a = Object.defineProperty || function(o, i, c) {
    o[i] = c.value;
  }, u = typeof Symbol == "function" ? Symbol : {}, s = u.iterator || "@@iterator", l = u.asyncIterator || "@@asyncIterator", h = u.toStringTag || "@@toStringTag";
  function d(o, i, c) {
    return Object.defineProperty(o, i, {
      value: c,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), o[i];
  }
  try {
    d({}, "");
  } catch {
    d = function(i, c, y) {
      return i[c] = y;
    };
  }
  function p(o, i, c, y) {
    var f = i && i.prototype instanceof b ? i : b, g = Object.create(f.prototype), _ = new oe(y || []);
    return a(g, "_invoke", {
      value: Te(o, c, _)
    }), g;
  }
  function w(o, i, c) {
    try {
      return {
        type: "normal",
        arg: o.call(i, c)
      };
    } catch (y) {
      return {
        type: "throw",
        arg: y
      };
    }
  }
  t.wrap = p;
  var k = "suspendedStart", R = "suspendedYield", v = "executing", C = "completed", m = {};
  function b() {
  }
  function A() {
  }
  function D() {
  }
  var H = {};
  d(H, s, function() {
    return this;
  });
  var x = Object.getPrototypeOf, $ = x && x(x(ae([])));
  $ && $ !== r && n.call($, s) && (H = $);
  var U = D.prototype = b.prototype = Object.create(H);
  function ye(o) {
    ["next", "throw", "return"].forEach(function(i) {
      d(o, i, function(c) {
        return this._invoke(i, c);
      });
    });
  }
  function z(o, i) {
    function c(f, g, _, S) {
      var L = w(o[f], o, g);
      if (L.type !== "throw") {
        var F = L.arg, G = F.value;
        return G && typeof G == "object" && n.call(G, "__await") ? i.resolve(G.__await).then(function(M) {
          c("next", M, _, S);
        }, function(M) {
          c("throw", M, _, S);
        }) : i.resolve(G).then(function(M) {
          F.value = M, _(F);
        }, function(M) {
          return c("throw", M, _, S);
        });
      }
      S(L.arg);
    }
    var y;
    a(this, "_invoke", {
      value: function(f, g) {
        function _() {
          return new i(function(S, L) {
            c(f, g, S, L);
          });
        }
        return y = y ? y.then(_, _) : _();
      }
    });
  }
  function Te(o, i, c) {
    var y = k;
    return function(f, g) {
      if (y === v)
        throw Error("Generator is already running");
      if (y === C) {
        if (f === "throw")
          throw g;
        return {
          value: e,
          done: !0
        };
      }
      for (c.method = f, c.arg = g; ; ) {
        var _ = c.delegate;
        if (_) {
          var S = ge(_, c);
          if (S) {
            if (S === m)
              continue;
            return S;
          }
        }
        if (c.method === "next")
          c.sent = c._sent = c.arg;
        else if (c.method === "throw") {
          if (y === k)
            throw y = C, c.arg;
          c.dispatchException(c.arg);
        } else
          c.method === "return" && c.abrupt("return", c.arg);
        y = v;
        var L = w(o, i, c);
        if (L.type === "normal") {
          if (y = c.done ? C : R, L.arg === m)
            continue;
          return {
            value: L.arg,
            done: c.done
          };
        }
        L.type === "throw" && (y = C, c.method = "throw", c.arg = L.arg);
      }
    };
  }
  function ge(o, i) {
    var c = i.method, y = o.iterator[c];
    if (y === e)
      return i.delegate = null, c === "throw" && o.iterator.return && (i.method = "return", i.arg = e, ge(o, i), i.method === "throw") || c !== "return" && (i.method = "throw", i.arg = new TypeError("The iterator does not provide a '" + c + "' method")), m;
    var f = w(y, o.iterator, i.arg);
    if (f.type === "throw")
      return i.method = "throw", i.arg = f.arg, i.delegate = null, m;
    var g = f.arg;
    return g ? g.done ? (i[o.resultName] = g.value, i.next = o.nextLoc, i.method !== "return" && (i.method = "next", i.arg = e), i.delegate = null, m) : g : (i.method = "throw", i.arg = new TypeError("iterator result is not an object"), i.delegate = null, m);
  }
  function Pe(o) {
    var i = {
      tryLoc: o[0]
    };
    1 in o && (i.catchLoc = o[1]), 2 in o && (i.finallyLoc = o[2], i.afterLoc = o[3]), this.tryEntries.push(i);
  }
  function ie(o) {
    var i = o.completion || {};
    i.type = "normal", delete i.arg, o.completion = i;
  }
  function oe(o) {
    this.tryEntries = [{
      tryLoc: "root"
    }], o.forEach(Pe, this), this.reset(!0);
  }
  function ae(o) {
    if (o || o === "") {
      var i = o[s];
      if (i)
        return i.call(o);
      if (typeof o.next == "function")
        return o;
      if (!isNaN(o.length)) {
        var c = -1, y = function f() {
          for (; ++c < o.length; )
            if (n.call(o, c))
              return f.value = o[c], f.done = !1, f;
          return f.value = e, f.done = !0, f;
        };
        return y.next = y;
      }
    }
    throw new TypeError(typeof o + " is not iterable");
  }
  return A.prototype = D, a(U, "constructor", {
    value: D,
    configurable: !0
  }), a(D, "constructor", {
    value: A,
    configurable: !0
  }), A.displayName = d(D, h, "GeneratorFunction"), t.isGeneratorFunction = function(o) {
    var i = typeof o == "function" && o.constructor;
    return !!i && (i === A || (i.displayName || i.name) === "GeneratorFunction");
  }, t.mark = function(o) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(o, D) : (o.__proto__ = D, d(o, h, "GeneratorFunction")), o.prototype = Object.create(U), o;
  }, t.awrap = function(o) {
    return {
      __await: o
    };
  }, ye(z.prototype), d(z.prototype, l, function() {
    return this;
  }), t.AsyncIterator = z, t.async = function(o, i, c, y, f) {
    f === void 0 && (f = Promise);
    var g = new z(p(o, i, c, y), f);
    return t.isGeneratorFunction(i) ? g : g.next().then(function(_) {
      return _.done ? _.value : g.next();
    });
  }, ye(U), d(U, h, "Generator"), d(U, s, function() {
    return this;
  }), d(U, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(o) {
    var i = Object(o), c = [];
    for (var y in i)
      c.push(y);
    return c.reverse(), function f() {
      for (; c.length; ) {
        var g = c.pop();
        if (g in i)
          return f.value = g, f.done = !1, f;
      }
      return f.done = !0, f;
    };
  }, t.values = ae, oe.prototype = {
    constructor: oe,
    reset: function(o) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(ie), !o)
        for (var i in this)
          i.charAt(0) === "t" && n.call(this, i) && !isNaN(+i.slice(1)) && (this[i] = e);
    },
    stop: function() {
      this.done = !0;
      var o = this.tryEntries[0].completion;
      if (o.type === "throw")
        throw o.arg;
      return this.rval;
    },
    dispatchException: function(o) {
      if (this.done)
        throw o;
      var i = this;
      function c(L, F) {
        return g.type = "throw", g.arg = o, i.next = L, F && (i.method = "next", i.arg = e), !!F;
      }
      for (var y = this.tryEntries.length - 1; y >= 0; --y) {
        var f = this.tryEntries[y], g = f.completion;
        if (f.tryLoc === "root")
          return c("end");
        if (f.tryLoc <= this.prev) {
          var _ = n.call(f, "catchLoc"), S = n.call(f, "finallyLoc");
          if (_ && S) {
            if (this.prev < f.catchLoc)
              return c(f.catchLoc, !0);
            if (this.prev < f.finallyLoc)
              return c(f.finallyLoc);
          } else if (_) {
            if (this.prev < f.catchLoc)
              return c(f.catchLoc, !0);
          } else {
            if (!S)
              throw Error("try statement without catch or finally");
            if (this.prev < f.finallyLoc)
              return c(f.finallyLoc);
          }
        }
      }
    },
    abrupt: function(o, i) {
      for (var c = this.tryEntries.length - 1; c >= 0; --c) {
        var y = this.tryEntries[c];
        if (y.tryLoc <= this.prev && n.call(y, "finallyLoc") && this.prev < y.finallyLoc) {
          var f = y;
          break;
        }
      }
      f && (o === "break" || o === "continue") && f.tryLoc <= i && i <= f.finallyLoc && (f = null);
      var g = f ? f.completion : {};
      return g.type = o, g.arg = i, f ? (this.method = "next", this.next = f.finallyLoc, m) : this.complete(g);
    },
    complete: function(o, i) {
      if (o.type === "throw")
        throw o.arg;
      return o.type === "break" || o.type === "continue" ? this.next = o.arg : o.type === "return" ? (this.rval = this.arg = o.arg, this.method = "return", this.next = "end") : o.type === "normal" && i && (this.next = i), m;
    },
    finish: function(o) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var c = this.tryEntries[i];
        if (c.finallyLoc === o)
          return this.complete(c.completion, c.afterLoc), ie(c), m;
      }
    },
    catch: function(o) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var c = this.tryEntries[i];
        if (c.tryLoc === o) {
          var y = c.completion;
          if (y.type === "throw") {
            var f = y.arg;
            ie(c);
          }
          return f;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(o, i, c) {
      return this.delegate = {
        iterator: ae(o),
        resultName: i,
        nextLoc: c
      }, this.method === "next" && (this.arg = e), m;
    }
  }, t;
}
function ce(e, t) {
  return ce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, ce(e, t);
}
function Ie(e, t) {
  return Me(e) || qe(e, t) || We(e, t) || He();
}
function Je(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function De(e) {
  var t = Je(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ue(e) {
  "@babel/helpers - typeof";
  return ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ue(e);
}
function We(e, t) {
  if (e) {
    if (typeof e == "string")
      return we(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? we(e, t) : void 0;
  }
}
const re = "kuc_persitent_register";
async function Ae(e) {
  try {
    let t = await e.getItem(re), r = +/* @__PURE__ */ new Date();
    I = t && JSON.parse(t) || [], await Promise.all(I.map(async (n) => {
      let a = await e.getItem(n), {
        update: u
      } = a && JSON.parse(a) || {};
      if (Math.floor((r - (u || r)) / 864e5) >= 7)
        try {
          await e.removeItem(n), I.splice(I.indexOf(n), 1);
        } catch {
        }
    })), I = I.filter((n) => n), await e.setItem(re, JSON.stringify(I));
  } catch {
  }
}
let I, Oe = async function(e) {
  Oe = () => {
  }, await Ae(e);
}, Be = async (e) => {
  if (I)
    return I;
  {
    let t = await e.getItem(re);
    return I = t && JSON.parse(t) || [], I;
  }
};
function q(e, t) {
  this.storage = e, this._encrypt = t, this.encrypt = null, this.gc();
}
q.prototype.initEncrypt = async function() {
  this.encrypt || (this._encrypt instanceof Promise ? this.encrypt = await this._encrypt : this._encrypt && (this.encrypt = this._encrypt));
};
q.prototype.setItem = async function(e, t) {
  let r = await Be(this.storage);
  await this.initEncrypt();
  try {
    if (this.encrypt && Object.prototype.toString.call(this.encrypt.encrypt) === "[object Function]") {
      let n = await this.encrypt.encrypt(JSON.stringify(t.items));
      t.items = n || JSON.stringify(t.items);
    } else
      t.items = JSON.stringify(t.items);
  } catch (n) {
    console.error(n);
    return;
  }
  ~r.indexOf(e) || (I.push(e), await this.storage.setItem(re, JSON.stringify(I))), await this.storage.setItem(e, JSON.stringify(t));
};
q.prototype.getItem = async function(e) {
  let t = await this.storage.getItem(e), r = t && JSON.parse(t) || null;
  if (await this.initEncrypt(), r && r.items)
    try {
      let n;
      this.encrypt && Object.prototype.toString.call(this.encrypt.decrypt) === "[object Function]" ? n = await this.encrypt.decrypt(r.items) : n = r.items, r.items = JSON.parse(n);
    } catch (n) {
      return console.error(n), this.removeItem(e), null;
    }
  return r;
};
q.prototype.removeItem = function(e) {
  return this.storage.removeItem(e);
};
q.prototype.gc = async function() {
  (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? await Ae(this.storage) : await Oe(this.storage);
};
function T(e) {
  this.L1Cache = {
    items: {},
    update: 0
  }, this.storage = new q(e.storage, e.encrypt), this.id = e.id, this.ns = e.namespace, this.nsKey = "", this.queue = [], this.allocation = e.allocation, this.maxAge = e.maxAge || e.L2MaxAge, this.commit2Disk = Se(() => {
    try {
      if (!Ne(this.L1Cache.items)) {
        let t = () => {
          this.cutDown(), this.storage.setItem(this.nsKey, {
            ...this.L1Cache
          });
        };
        this.L1Cache.update = +/* @__PURE__ */ new Date(), this.nsKey && (typeof window < "u" && window.requestIdleCallback ? window.requestIdleCallback(t) : t());
      }
    } catch {
    }
  }, 1e3), this.L1CacheHandler = this.initL1Cache();
}
T.prototype.init = async function() {
  let e = this.id;
  if (this.id)
    if (this.id instanceof Promise)
      e = await this.id;
    else if (typeof this.id == "function") {
      let t = this.id;
      e = t();
    } else
      e = this.id.toString && this.id.toString() || "";
  e && (this.nsKey = "".concat(this.ns, "_").concat(e));
};
T.prototype.cutDown = function() {
  let e = () => {
    let t = JSON.stringify(this.L1Cache);
    return Math.floor(unescape(encodeURIComponent(t)).length / 1024);
  };
  for (; e() > this.allocation; ) {
    let t = this.queue.shift();
    try {
      delete this.L1Cache.items[t];
    } catch {
    }
  }
};
T.prototype.initL1Cache = async function() {
  if (await this.init(), this.nsKey) {
    let e = await this.storage.getItem(this.nsKey);
    this.L1Cache = K({}, e, this.L1Cache);
    let {
      items: t
    } = this.L1Cache;
    this.queue = Re(t).sort((r, n) => r[1].expired > n[1].expired ? 1 : r[1].expired < n[1].expired ? -1 : 0).map((r) => r[0]);
  }
};
T.prototype.write = async function(e, t, r) {
  this.L1Cache.items[e] = {
    data: t,
    expired: +/* @__PURE__ */ new Date() + (r || this.maxAge)
  }, await this.init(), this.queue = this.queue.filter((n) => n !== e), this.queue.push(e), this.L1CacheHandler.then(() => this.commit2Disk());
};
T.prototype.read = async function(e) {
  return await this.init(), await this.L1CacheHandler, this.L1Cache.items[e];
};
T.prototype.reset = function() {
  this.L1Cache = {
    items: {},
    update: 0
  }, this.queue = [];
};
T.prototype.delete = async function(e) {
  if (await this.L1CacheHandler, e) {
    try {
      delete this.L1Cache.items[e], this.commit2Disk();
    } catch {
    }
    this.queue = this.queue.filter((t) => t !== e);
  } else
    this.storage.removeItem(this.nsKey), this.queue = [];
};
function Ye() {
  var e;
  return typeof window < "u" && window.localStorage ? e = window.localStorage : typeof process < "u" && Object.prototype.toString.call(process) === "[object process]" && (e = {
    getItem: () => {
    },
    setItem: () => {
    },
    removeItem: () => {
    }
  }), e;
}
var ne = {
  mode: "memory",
  offline: !0,
  offlineStatus: (e) => !e.response,
  syncDisk: !0,
  asyncDisk: !1,
  namespace: "kuc_persitent_data",
  storage: Ye(),
  id: "",
  allocation: 512,
  L1MaxAge: 2e3,
  L2MaxAge: 6048e5,
  foreUpdate: !1
};
function Y(e) {
  this.hanlders = {}, this.producer = {}, this.maxAge = e && e.L1MaxAge || ne.L1MaxAge;
}
Y.prototype.read = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    maxAge: n
  } = r, a = this.hanlders[e];
  if (!e)
    throw new Error("key 为必须选参数");
  if (typeof e != "string")
    throw new Error("key 为必须为字符串");
  if (!t)
    throw new Error("Memery read函数参数callback不能空");
  if (typeof t != "function")
    throw new Error("Memery read函数参数callback类型必须为function");
  return a || (a = this.hanlders[e] = {
    result: t(),
    update: +/* @__PURE__ */ new Date(),
    remove: n === 0 ? () => {
    } : Se(() => {
      this.hanlders[e] && delete this.hanlders[e];
    }, n || this.maxAge)
  }), a.remove(), a.result;
};
Y.prototype.reset = function() {
  Object.keys(this.hanlders).forEach((e) => {
    this.remove(e);
  }), this.hanlders = {}, this.producer = {};
};
Y.prototype.consumer = function(e, t) {
  const r = this.producer[e] === void 0;
  let n;
  return r ? (this.producer[e] = "production", n = this.read(e, t, {
    maxAge: 0
  })) : (n = this.read(e, t), this.producer[e] === "production" && (this.remove(e), this.producer[e] = "consumed")), n;
};
Y.prototype.remove = function(e) {
  this.hanlders[e] && (this.hanlders[e].remove.cancel && this.hanlders[e].remove.cancel(), delete this.hanlders[e]);
};
function N(e) {
  if (this.defaults = e, this.idDefer = Promise.resolve(e.id), typeof e.id == "function") {
    let t = e.id();
    t instanceof Promise ? this.idDefer = new Promise((r, n) => {
      t.then((a) => {
        typeof t == "string" || typeof t == "number" ? r(a) : n("unsupportType");
      }, (a) => n(a));
    }) : typeof t == "string" || typeof t == "number" ? this.idDefer = Promise.resolve(t) : this.idDefer = Promise.reject("unsupportType");
  }
  this.diskL1 = new T(K({}, e, {
    id: this.idDefer,
    storage: e.storage,
    ns: e.namespace + "_L1",
    allocation: 128
  })), this.diskL2 = new T(K({}, e, {
    id: this.idDefer,
    storage: e.storage,
    ns: e.namespace + "_L2"
  })), this.memory = new Y(e);
}
N.prototype.L1Get = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return this.get(e, t, K({
    mode: "memory",
    offline: !0
  }, r));
};
N.prototype.L2Get = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return this.get(e, t, K({
    mode: "disk",
    asyncDisk: !0
  }, r));
};
N.prototype.L3Get = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return this.get(e, t, K({
    mode: "disk",
    asyncDisk: !1
  }, r));
};
N.prototype.get = async function(e, t, r) {
  let n = K({}, this.defaults, r || {}), a, u = async () => {
    let {
      offline: s,
      offlineStatus: l
    } = n;
    try {
      a = await this.memory.read(e, t, n), s && this.diskL1.write(e, a);
    } catch (h) {
      if (s && l(h)) {
        let d = await this.diskL1.read(e);
        if (d)
          a = d.data;
        else
          throw h;
      } else
        throw h;
    }
    return a;
  };
  if (n.mode === "memory")
    return await u();
  {
    let {
      asyncDisk: s
    } = n, l = await this.diskL2.read(e);
    if (l && l.expired && !n.foreUpdate && +/* @__PURE__ */ new Date() <= l.expired) {
      let d = l.data;
      if (d) {
        if (s) {
          let p = !1;
          typeof s == "function" ? p = s() : typeof p == "boolean" && (p = s), p && u().then((w) => this.diskL2.write(e, w), () => {
          });
        }
        return d;
      }
    }
    let h = await u();
    return this.diskL2.write(e, h), h;
  }
};
N.prototype.reset = function() {
  this.memory.reset(), this.diskL1.reset(), this.diskL2.reset();
};
N.prototype.destroy = function() {
  this.reset(), this.diskL1.delete(), this.diskL2.delete();
};
function $e(e) {
  function t() {
  }
  return t.prototype = e, new t();
}
function ze(e, t) {
  let r = $e(t.prototype);
  r.constructor = e, e.prototype = r;
}
function B(e) {
  N.call(this, e);
}
ze(B, N);
B.prototype.create = function(e) {
  const t = K({}, ne);
  return e.storage ? (delete t.storage, new B(K({}, t, e))) : new B(K({}, ne, e));
};
const Ve = new B(ne);
var Xe = "https://kuc.wps.cn", Qe = ["test-edu.kdocs.cn", "edu.kdocs.cn", "pc.kdocs.cn", "qr.kdocs.cn", "internal.kdocs.cn", "docs.kdocs.cn", "www.kdocs.cn", "meeting.kdocs.cn", "plussvr.kdocs.cn", "dc.kdocs.cn", "docer.kdocs.cn", "docer-vcl.kdocs.cn", "vipapi.kdocs.cn", "plus.kdocs.cn", "pub.kdocs.cn", "rili.kdocs.cn", "f.kdocs.cn", "securitydoc.kdocs.cn", "hd.kdocs.cn", "docer-mo.kdocs.cn", "im.kdocs.cn", "kanban-woa.kdocs.cn", "todo.kdocs.cn", "report-woa.kdocs.cn"];
function Ke() {
  try {
    return new Function('import("")'), !0;
  } catch {
    return !1;
  }
}
function _e(e) {
  return le.apply(this, arguments);
}
function le() {
  return le = j(/* @__PURE__ */ E().mark(function e(t) {
    var r, n, a = arguments;
    return E().wrap(function(s) {
      for (; ; )
        switch (s.prev = s.next) {
          case 0:
            r = a.length > 1 && a[1] !== void 0 ? a[1] : "", n = a.length > 2 && a[2] !== void 0 ? a[2] : "auto", s.t0 = n, s.next = s.t0 === "umd" ? 5 : s.t0 === "es" ? 6 : 7;
            break;
          case 5:
            return s.abrupt("return", ke(t, r).then(function(l) {
              return l;
            }));
          case 6:
            return s.abrupt("return", be(t).then(function(l) {
              return l;
            }));
          case 7:
            return s.abrupt("return", Ke() ? be(t) : ke(t, r));
          case 8:
          case "end":
            return s.stop();
        }
    }, e);
  })), le.apply(this, arguments);
}
function ke(e) {
  return fe.apply(this, arguments);
}
function fe() {
  return fe = j(/* @__PURE__ */ E().mark(function e(t) {
    var r, n, a = arguments;
    return E().wrap(function(s) {
      for (; ; )
        switch (s.prev = s.next) {
          case 0:
            return r = a.length > 1 && a[1] !== void 0 ? a[1] : "", n = t.url, s.next = 4, Ce(n, "text").then(function(l) {
              new Function(l)();
              var h = r ? Ze(r) : "";
              if (h && window[h])
                return window[h];
              throw new Error("UMD module not found");
            });
          case 4:
            return s.abrupt("return", s.sent);
          case 5:
          case "end":
            return s.stop();
        }
    }, e);
  })), fe.apply(this, arguments);
}
function be(e) {
  return he.apply(this, arguments);
}
function he() {
  return he = j(/* @__PURE__ */ E().mark(function e(t) {
    return E().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", new Promise(function(a, u) {
              var s = "__load_sdk_".concat(Math.random()), l = document.createElement("script");
              l.type = "module";
              function h() {
                l.parentNode && l.parentNode.removeChild(l), delete window[s];
              }
              window[s] = {
                resolve: function(w) {
                  a(w.default || w), h();
                },
                reject: function(w) {
                  u(w), h();
                }
              };
              var d = "import('".concat(t.url, "').then(res => window['").concat(s, "'].resolve(res)).catch(e => window['").concat(s, "'].reject(e))");
              l.innerHTML = d, l.onerror = function(p) {
                return u(p);
              }, document.head.appendChild(l);
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), he.apply(this, arguments);
}
function de() {
  var e = {};
  return e.promise = new Promise(function(t, r) {
    e.resolve = t, e.reject = r;
  }), e;
}
var Ce = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "json";
  return window.fetch ? window.fetch(t, {
    mode: "cors"
  }).then(function(n) {
    return r === "json" ? n.json() : n.text();
  }) : new Promise(function(n, a) {
    var u = new XMLHttpRequest();
    u.open("GET", t), u.onload = function() {
      try {
        if (r === "json") {
          n(JSON.parse(u.response));
          return;
        }
        n(u.response);
      } catch (s) {
        a(s);
      }
    }, u.onerror = function() {
      a(u.statusText);
    }, u.send();
  });
}, Ze = function(t) {
  var r = t.split("-").map(function(n) {
    return n.charAt(0).toUpperCase() + n.slice(1);
  }).join("");
  return "_widget".concat(r);
}, et = function() {
  var t = de(), r = t.promise, n = t.resolve;
  return window.requestIdleCallback ? window.requestIdleCallback(function() {
    return n(!0);
  }) : n(!0), r;
};
function tt(e) {
  return /(^|\.)kdocs\.cn$/.test(e);
}
var J, rt = function() {
  if (J)
    return J;
  var t = tt(location.origin);
  return !t || Qe.includes(location.hostname) ? J = Xe : J = "".concat(location.origin, "/3rd/kuc"), J;
}, nt = Object.defineProperty, it = function(t, r, n) {
  return r in t ? nt(t, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : t[r] = n;
}, O = function(t, r, n) {
  return it(t, ue(r) != "symbol" ? r + "" : r, n), n;
}, se;
function ot() {
  return se || (se = import("@dw/js-sdk/dist/WebReporter.js"), se);
}
var at = /* @__PURE__ */ function() {
  function e(t) {
    pe(this, e), O(this, "appKey"), O(this, "incomes", []), O(this, "dw"), O(this, "debug"), O(this, "logServer"), O(this, "channel", "");
    var r = t.appKey, n = t.debug, a = t.logServer;
    this.appKey = r || "f37b6da8ceddc9c7", this.debug = n || a && !0 || !1, this.logServer = a, this.incomes = [], this.channel = t.channel || this.getChannel(), this.init();
  }
  return me(e, [{
    key: "getChannel",
    value: function() {
      return window.__API_CACHED__ && window.__INITIAL_STATE__ && window.__INITIAL_STATE__.user ? "cloud" : window.__WPSURL__ && window.__WPSURL__.feature === "client-collaboration-switch" && window.__WPSURL__.openshare ? "client-switch-cloud" : window.__WPSENV__ && window.WPSOpenApi ? "weboffice" : "";
    }
  }, {
    key: "init",
    value: function() {
      var t = j(/* @__PURE__ */ E().mark(function n() {
        var a = this, u;
        return E().wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.next = 2, window.requestIdleCallback && new Promise(function(h) {
                  window.requestIdleCallback(function() {
                    return h(!0);
                  }, {
                    timeout: 1e3
                  });
                }) || new Promise(function(h) {
                  setTimeout(h, 1e3);
                });
              case 2:
                return l.next = 4, ot();
              case 4:
                u = l.sent.default, this.dw = new u().setAppKey(this.appKey), this.dw.setChannel(this.channel), this.dw.setDebug(this.debug), this.incomes.length && (this.incomes.forEach(function(h) {
                  var d = Ie(h, 2), p = d[0], w = d[1];
                  a.onEvent(p, w);
                }), this.incomes = []);
              case 6:
              case "end":
                return l.stop();
            }
        }, n, this);
      }));
      function r() {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }, {
    key: "onEvent",
    value: function(r, n) {
      if (!this.dw)
        this.incomes.push([r, n]);
      else
        try {
          this.dw.onEvent(r, n), this.console({
            title: r,
            data: n
          });
        } catch (a) {
          this.debug && this.console({
            title: "Reporter sendDwEvent fail",
            type: "error",
            data: a && a.message
          });
        }
    }
  }, {
    key: "console",
    value: function(t) {
      function r(n) {
        return t.apply(this, arguments);
      }
      return r.toString = function() {
        return t.toString();
      }, r;
    }(function(t) {
      var r = t.title, n = t.type, a = n === void 0 ? "info" : n, u = t.data;
      if (this.logServer) {
        var s = this.logServer, l = s.protocol, h = l === void 0 ? "http" : l, d = s.hostname, p = s.port, w = p === void 0 ? 80 : p, k = s.pathname, R = k === void 0 ? "/" : k, v = "".concat(h, "://").concat(d, ":").concat(w).concat(R, "?msg=").concat(JSON.stringify(t));
        window.fetch(v, {
          mode: "cors"
        });
      } else {
        var C = document.cookie, m = /(?:^|;\s*)KUC_REPORTER_TARGET=([^;]*)/, b = C.match(m);
        b && window.fetch("".concat(b[1], "?msg=").concat(JSON.stringify(t)), {
          mode: "cors"
        });
      }
      a === "error" ? console.error(r, u) : a === "warn" ? console.warn(r, u) : this.debug && console.log(r, u);
    })
  }]);
}(), Ee = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    pe(this, t), n = xe(this, t, [r]), O(n, "measures", []), O(n, "marks", []), O(n, "id"), O(n, "name");
    var a = r.name;
    return n.name = a, n;
  }
  return Fe(t, e), me(t, [{
    key: "mark",
    value: function(n) {
      return performance.mark(n), this;
    }
  }, {
    key: "measure",
    value: function(n, a, u) {
      var s = "".concat(this.name, "_").concat(n);
      if (~this.measures.indexOf(s))
        this.console({
          title: "duplication measure",
          type: "warn",
          data: "".concat(s, " is existed, skip")
        });
      else {
        var l = 0, h = "";
        try {
          l = performance.measure(s, a, u).duration, this.measures.push(s), this.marks.push([a, u]), this.onEvent(this.name, {
            measure: n,
            duration: l,
            err: h
          });
        } catch (d) {
          h = d.message, console.error(h);
        }
      }
      return this;
    }
  }, {
    key: "clean",
    value: function() {
      return this.measures.forEach(function(n) {
        return performance.clearMeasures(n);
      }), this.marks.forEach(function(n) {
        var a = Ie(n, 2), u = a[0], s = a[1];
        performance.clearMarks(u), performance.clearMarks(s);
      }), this.measures = [], this.marks = [], this;
    }
  }]);
}(at), X = "__UIKIT_SDK_LOADER_INSTANCE_MAP__", Q = "__UIKIT_SDK_LOADER_PROMISE_MAP__", Z = "__UIKIT_SDK_LOADER_MANIFEST__", ee = {
  setItem: function(t, r) {
    window[X] || (window[X] = {}), window[X][t] = r;
  },
  getItem: function(t) {
    var r;
    return (r = window[X]) === null || r === void 0 ? void 0 : r[t];
  }
}, P = {
  setItem: function(t, r) {
    window[Q] || (window[Q] = {}), window[Q][t] = r;
  },
  getItem: function(t) {
    var r;
    return (r = window[Q]) === null || r === void 0 ? void 0 : r[t];
  }
}, W = {
  setItem: function(t, r) {
    window[Z] || (window[Z] = {}), window[Z][t] = r;
  },
  getItem: function(t) {
    return (window[Z] || {})[t];
  }
}, st = /* @__PURE__ */ function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    pe(this, e), V(this, "plugins", []), V(this, "config", void 0), V(this, "sdk", "file-share"), V(this, "url", ""), this.sdk = t, this.config = r;
  }
  return me(e, [{
    key: "moduleFormat",
    get: function() {
      return this.config.format ? this.config.format : Ke() ? "es" : "umd";
    }
  }, {
    key: "pluginHooks",
    get: function() {
      var r = this, n = function(u) {
        return r.plugins.map(function(s) {
          return s[u] && s[u](r);
        });
      };
      return {
        beforeLoad: function() {
          return n("beforeLoad");
        },
        afterLoad: function() {
          return n("afterLoad");
        },
        loadError: function() {
          return n("loadError");
        }
      };
    }
  }, {
    key: "getManifest",
    value: function() {
      var t = j(/* @__PURE__ */ E().mark(function n() {
        var a = this, u, s, l, h, d, p, w, k;
        return E().wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                if (u = "".concat(this.moduleFormat), !W.getItem(u)) {
                  v.next = 3;
                  break;
                }
                return v.abrupt("return", W.getItem(u));
              case 3:
                return s = Date.now(), l = de(), h = l.resolve, d = l.reject, p = l.promise, w = Ve.create({
                  id: u,
                  namespace: "KUC_SDK_LOADER_manifest",
                  mode: "disk",
                  asyncDisk: !0
                }), v.next = 8, w.get("data", /* @__PURE__ */ j(/* @__PURE__ */ E().mark(function C() {
                  var m;
                  return E().wrap(function(A) {
                    for (; ; )
                      switch (A.prev = A.next) {
                        case 0:
                          return performance.mark("KUC_SDK_LOADER_MAINFEST_API_START_".concat(s)), A.next = 3, Ce("".concat(rt(), "/uikit/sdk/manifest/all?format=").concat(a.moduleFormat)).then(function(D) {
                            var H = new Ee({
                              name: "mainfest_api"
                            });
                            if (performance.mark("KUC_SDK_LOADER_MAINFEST_API_END_".concat(s)), H.measure(a.sdk, "KUC_SDK_LOADER_MAINFEST_API_START_".concat(s), "KUC_SDK_LOADER_MAINFEST_API_END_".concat(s)), D.status !== "success") {
                              var x = new Error(JSON.stringify(D));
                              throw d(x), x;
                            }
                            return h(D.data), D.data;
                          });
                        case 3:
                          return m = A.sent, W.setItem(u, m), A.abrupt("return", m);
                        case 6:
                        case "end":
                          return A.stop();
                      }
                  }, C);
                })));
              case 8:
                if (k = v.sent, W.setItem(u, k), k[this.sdk]) {
                  v.next = 14;
                  break;
                }
                return v.next = 13, p;
              case 13:
                k = v.sent;
              case 14:
                return v.abrupt("return", k);
              case 15:
              case "end":
                return v.stop();
            }
        }, n, this);
      }));
      function r() {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }, {
    key: "load",
    value: function() {
      var t = j(/* @__PURE__ */ E().mark(function n() {
        var a = this, u, s, l, h, d, p, w, k, R, v = arguments;
        return E().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                if (u = v.length > 0 && v[0] !== void 0 ? v[0] : {}, s = de(), l = s.resolve, h = s.reject, d = s.promise, p = "".concat(this.sdk, "_").concat(Date.now()), performance.mark("KUC_SDK_LOADER_START_".concat(p)), m.prev = 4, w = u.preload || [], this.pluginHooks.beforeLoad(), this.config.noCache) {
                  m.next = 15;
                  break;
                }
                if (!P.getItem(this.sdk)) {
                  m.next = 11;
                  break;
                }
                return m.next = 11, P.getItem(this.sdk).catch(function() {
                });
              case 11:
                if (!ee.getItem(this.sdk)) {
                  m.next = 15;
                  break;
                }
                return this.loadAdditionalSdk(w), this.pluginHooks.afterLoad(), m.abrupt("return", ee.getItem(this.sdk));
              case 15:
                return P.setItem(this.sdk, d), m.next = 18, this.getManifest();
              case 18:
                if (k = m.sent, performance.mark("KUC_SDK_LOADER_MAINFEST_END_".concat(p)), k[this.sdk]) {
                  m.next = 22;
                  break;
                }
                throw new Error("SDK ".concat(this.sdk, " 不存在"));
              case 22:
                if (this.url = k[this.sdk].url, u.skipIdle) {
                  m.next = 27;
                  break;
                }
                return m.next = 26, et();
              case 26:
                performance.mark("KUC_SDK_LOADER_IDLE_END_".concat(p));
              case 27:
                return w.length && this.loadAdditionalSdk(w), m.next = 30, _e(k[this.sdk], this.sdk, this.moduleFormat).then(function(b) {
                  return ee.setItem(a.sdk, b), P.setItem(a.sdk, null), b;
                });
              case 30:
                R = m.sent, this.pluginHooks.afterLoad(), l(R), m.next = 40;
                break;
              case 35:
                m.prev = 35, m.t0 = m.catch(4), P.setItem(this.sdk, null), this.pluginHooks.loadError(), h(m.t0);
              case 40:
                return d.catch(function() {
                  performance.mark("KUC_SDK_LOADER_FAIL_".concat(p));
                }).finally(function() {
                  performance.mark("KUC_SDK_LOADER_END_".concat(p));
                  var b = new Ee({
                    name: "kuc_sdk_loader"
                  });
                  performance.getEntriesByName("KUC_SDK_LOADER_MAINFEST_END_".concat(p)).length && b.measure("mainfest", "KUC_SDK_LOADER_START_".concat(p), "KUC_SDK_LOADER_MAINFEST_END_".concat(p)), performance.getEntriesByName("KUC_SDK_LOADER_IDLE_END_".concat(p)).length && b.measure("idle", "KUC_SDK_LOADER_MAINFEST_END_".concat(p), "KUC_SDK_LOADER_IDLE_END_".concat(p)), performance.getEntriesByName("KUC_SDK_LOADER_FAIL").length ? b.measure("".concat(a.sdk, "_fail"), "KUC_SDK_LOADER_START_".concat(p), "KUC_SDK_LOADER_FAIL_".concat(p)) : b.measure(a.sdk, "KUC_SDK_LOADER_START_".concat(p), "KUC_SDK_LOADER_END_".concat(p)), b.clean();
                }), m.abrupt("return", d);
              case 42:
              case "end":
                return m.stop();
            }
        }, n, this, [[4, 35]]);
      }));
      function r() {
        return t.apply(this, arguments);
      }
      return r;
    }()
    // 预加载sdk, 用于提前加载一些依赖的sdk, 不会返回实例
  }, {
    key: "loadAdditionalSdk",
    value: function() {
      var r = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], a = W.getItem(this.moduleFormat) || {};
      n.forEach(function(u) {
        if (a[u]) {
          var s = a[u], l = s.url, h = s.integrity, d = _e({
            url: l,
            integrity: h
          }, u, r.moduleFormat);
          P.setItem(u, d), d.then(function(p) {
            ee.setItem(u, p), P.setItem(u, null);
          }).catch(function() {
            P.setItem(u, null);
          });
        }
      });
    }
  }, {
    key: "usePlugin",
    value: function(r) {
      return this.plugins.push(r), this;
    }
  }]);
}();
function ht(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    env: "public"
  };
  return new st(e, t);
}
export {
  ht as default
};
